import { useParams } from "react-router-dom";
import { TitleWithDivider } from "@common/TitleWithDivider";
import UserInformation from "@components/Forms/UserProfileForm";
import { error_message } from "@constants/Errors";
import pageHeaders from "@constants/PageHeaders";

const ViewCurrentUserPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.USER.create}
          useDivider={true}
        />
        <UserInformation
          id={id != null ? id : error_message.generic.unknown}
        ></UserInformation>
      </div>
    </>
  );
};

export default ViewCurrentUserPage;
